import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Timeline } from 'antd';
import getBreakpointView from 'utils/getBreakpointView';
import useIsClient from 'hooks/useIsClient';
import Text from '../Text/index';
import { STIcon } from '../Brand/Icons/STIcon';
import { CareersTimelineSection } from './styles';

const CareersTimeline = ({ background, title, pastMilestones, ...otherProps }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);
  const isClient = useIsClient();
  const milestones = pastMilestones;

  return (
    <CareersTimelineSection background={background} {...otherProps}>
      <div className="section-company-milestones--container">
        <Text type="h2" className="careers--underlined-heading" id="titanstory">
          Milestones
        </Text>
        <div className="section-company-milestones--content">
          {isClient && (
            <Timeline
              className="section-company-milestones--timeline"
              mode={isMobile ? 'left' : 'alternate'}
            >
              {milestones.map((milestoneItem, index) => {
                return (
                  <Timeline.Item key={index}>
                    <div className="section-company-milestones--item">
                      <div className="section-company-milestones--item-icon">
                        <hr />
                        <STIcon type={'icon-' + milestoneItem.iconType}></STIcon>
                      </div>
                      <div className="section-company-milestones--item-text">
                        <Text type="p" className="section-company-milestones--item-date">
                          {milestoneItem.title}
                        </Text>
                        <Text type="p" className="section-company-milestones--item-description">
                          {milestoneItem.description}
                        </Text>
                      </div>
                    </div>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          )}
        </div>
      </div>
    </CareersTimelineSection>
  );
};

CareersTimelineSection.propTypes = {
  title: PropTypes.string,
  milestones: PropTypes.array,
};

export default CareersTimeline;
